/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Aqui habia un buscador propio (fetch a /search/suggest.json que pintaba
 * <a class="sirena-search-item"> con la foto a tamano original dentro de
 * .search-bar__results-inner). Competia con las sugerencias del tema y, cuando
 * su respuesta llegaba de ultima, las fotos salian gigantes. Se quito: las
 * sugerencias las pinta solo el tema.
 */

/**
 * ==========================================================
 * FIX: el carrito no se actualizaba al pedir mas unidades de las que hay
 * ==========================================================
 * Cuando el cliente pide mas cantidad de la disponible, Shopify SI anade las
 * unidades que quedan, pero responde /cart/add.js con HTTP 422 y el mensaje
 * "Debido a la disponibilidad, solo se anadieron N articulos al carrito.".
 * El tema (theme.js) trata cualquier respuesta distinta de 200 como un fallo:
 * muestra el mensaje pero NO refresca el contador de la cabecera ni el
 * mini-carrito, asi que el cliente ve el carrito igual que antes y cree que no
 * se anadio nada (hasta recargar la pagina).
 *
 * Aqui interceptamos esa respuesta 422 y disparamos "product:added", el hook
 * documentado arriba, para que el tema vuelva a pintar el mini-carrito y el
 * contador con lo que realmente hay en el carrito. La cantidad va en 0 porque
 * el tema sobrescribe el contador con el valor real que devuelve el servidor.
 */
(function () {
  if (window.__sirenaPartialAddFix) {
    return;
  }

  window.__sirenaPartialAddFix = true;

  const originalFetch = window.fetch;

  window.fetch = function (input) {
    const url = typeof input === "string" ? input : (input && input.url) || "";
    const isCartAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);

    return originalFetch.apply(this, arguments).then(function (response) {
      if (isCartAdd && response.status === 422) {
        setTimeout(function () {
          document.documentElement.dispatchEvent(new CustomEvent("product:added", {
            bubbles: true,
            detail: {
              quantity: 0
            }
          }));
        }, 0);
      }

      return response;
    });
  };
})();